import { Col, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { CountryList } from "../../../data/holidays/CountryList";
import { dynamicImageflags } from "../../../service";
import { Image } from "../../../AbstractElements";

const CountryListData = () => {
  const navigate = useNavigate();

  const oHandleClickYears = (countryName: string) => {
    navigate(
      `${process.env.PUBLIC_URL}/holidays/country/${encodeURIComponent(
        countryName
      )}`
    );
  };

  return (
    <Row className="g-sm-4 g-3">
      {CountryList.map((item, index) => (
        <Col xl="4" md="6" key={index}>
          <div
            className="prooduct-details-box"
            onClick={() => oHandleClickYears(item.name)}
            style={{ cursor: "pointer" }}
          >
            <div  className="d-flex" style={{ gap: window.innerWidth <= 428 ? '8px' : '12px' }}>
              <Image
                className="align-self-center img-fluid img-60"
                src={dynamicImageflags(`flag-icon/${item.image}`)}
                alt="#"
              />
              <div className="flex-grow-1 ms-2 ms-md-3">
                <div>
                  <div>{item?.name}</div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default CountryListData;
